module.exports = __webpack_public_path__ + "linea-basic-elaboration-10.7193d8c51aea93b5f575.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/linea/fonts/linea-basic-elaboration-10.eot
// module id = ../../../../../src/assets/linea/fonts/linea-basic-elaboration-10.eot
// module chunks = styles